import { render, staticRenderFns } from "./technical-knowledge.component.vue?vue&type=template&id=5354e00a&scoped=true&"
import script from "./technical-knowledge.component.vue?vue&type=script&lang=ts&"
export * from "./technical-knowledge.component.vue?vue&type=script&lang=ts&"
import style0 from "./technical-knowledge.component.vue?vue&type=style&index=0&id=5354e00a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354e00a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
